import i18n from '../../i18n';

/**
 * Get the full name of a customer.
 * @param {string} firstname - The first name of the customer.
 * @param {string} lastname - The last name of the customer.
 * @returns {string} The full name of the customer.
 */
export const getFullname = (firstname, lastname) => `${firstname} ${lastname}`;

export const CUSTOMER_STATUS = [
  { label: i18n.t('customerStatus.rejected'), value: 'rejected' },
  { label: i18n.t('customerStatus.validate'), value: 'validate' },
  { label: i18n.t('customerStatus.pending'), value: 'pending' },
];
